<template>
  <div>
    <b-modal
      v-model="modalShow"
      :title="title"
      hide-footer
      centered
      header-class=""
    >
      <div>
        <div>
          <InputText
            :id="[
              actionType == 1
                ? 'inputAddStock' + form.ProductId
                : actionType == 2
                ? 'inputDecreaseStock' + form.ProductId
                : 'inputAdjustStock' + form.ProductId,
            ]"
            textFloat="หน่วย"
            v-model="form.TotalStock"
            class="mr-2"
            placeholder="หน่วย"
            type="number"
            :isValidate="$v.form.TotalStock.$error"
            isRequired
            :v="$v.form.TotalStock"
            @onKeyup="getProductStockChange"
          />
        </div>
        <div>
          <span class="font-weight-bold"> สต๊อก: </span>
          <span class="pl-3">{{ productSectectedStock }}</span>
          <span class="px-3"> <font-awesome-icon icon="arrow-right"/></span>
          <span
            :id="[
              actionType == 1
                ? 'productStockAddChange' + form.ProductId
                : actionType == 2
                ? 'productStockDecreaseChange' + form.ProductId
                : 'productStockAdjustChange' + form.ProductId,
            ]"
          >
            {{ productStockChange }}</span
          >
        </div>
        <div class="d-flex justify-content-center mt-4">
          <div class="ml-2">
            <b-button
              class="w-100 btn-main"
              @click="onCheckform"
              :disabled="isDisable"
              :id="[
                actionType == 1
                  ? 'saveAddStock' + form.ProductId
                  : actionType == 2
                  ? 'saveDecreaseStock' + form.ProductId
                  : 'saveAdjustStock' + form.ProductId,
              ]"
              >บันทึก</b-button
            >
          </div>
        </div>
      </div>
    </b-modal>
    <ModalAlert
      ref="modalAlert"
      :text="modalMessage"
      v-on:hadleModalAlertClose="hadleModalAlertClose"
    />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import { required, minValue } from "vuelidate/lib/validators";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalLoading from "@/components/modal/alert/ModalLoading";
export default {
  components: {
    InputText,
    ModalAlert,
    ModalAlertError,
    ModalLoading,
  },
  props: {
    actionType: {
      required: true,
      type: Number,
    },
    productSectectedId: {
      required: true,
      type: Number,
    },
    productSectectedStock: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      modalShow: false,
      title: "",
      form: { ProductId: 0, TotalStock: 0 },
      productStockChange: 0,
      modalMessage: "",
      isDisable: false,
    };
  },
  validations: {
    form: {
      TotalStock: { required, minValue: minValue(1) },
    },
  },
  methods: {
    hadleModalAlertClose() {
      this.hide();
    },
    onCheckform() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      }
      if (this.actionType == 1) {
        this.onSaveStock("add");
      } else if (this.actionType == 2) {
        this.onSaveStock("decrease");
      } else {
        this.onSaveStock("adjust");
      }
    },
    onSaveStock: async function(actionType) {
      this.isDisable = true;
      this.$refs.modalLoading.show();
      await this.axios
        .post(`${this.$baseUrl}/productInventory/${actionType}`, this.form)
        .then((data) => {
          this.isDisable = false;
          if (data.result == 1) {
            this.modalMessage = "สำเร็จ";
            this.$refs.modalLoading.hide();
            this.$refs.modalAlert.show();
            this.$emit("onRefreshProductList");
          } else {
            this.modalMessage = data.message;
            this.$refs.modalLoading.hide();
            this.$refs.modalAlertError.show();
          }
        });
    },
    getProductStockChange() {
      if (this.form.TotalStock) {
        if (this.actionType == 1) {
          return (this.productStockChange =
            this.productSectectedStock + parseInt(this.form.TotalStock));
        } else if (this.actionType == 2) {
          return (this.productStockChange =
            this.productSectectedStock - parseInt(this.form.TotalStock));
        } else {
          return (this.productStockChange = parseInt(this.form.TotalStock));
        }
      }
    },
    show() {
      if (this.actionType == 1) {
        this.title = "เพิ่มสต็อก";
      } else if (this.actionType == 2) {
        this.title = "ลดสต็อก";
      } else {
        this.title = "ปรับสต็อก";
      }
      this.form.ProductId = this.productSectectedId;
      this.form.TotalStock = 0;
      this.productStockChange = 0;
      this.$v.form.$reset();
      this.modalShow = true;
    },
    hide() {
      this.modalShow = false;
    },
  },
};
</script>

<style scoped></style>
